import { JobFuntionsType } from '@aibees/elephant/components/buying-team-tabs';
import { DataConfig } from '@aibees/elephant/components/sortable-table';
import { ParsedPreset } from '@aibees/shared/definition';
import { useBoolean } from '@aibees/shared/hooks/use-boolean';
import { createContext, useContext, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  BuyingTeamDialogsContextData as ContextData,
  BuyingTeamDialogsContextProps as ContextProps,
} from './types';

const context = createContext<ContextData>({} as ContextData);

export const { Provider } = context;

export const useBuyingTeamDialogsContext = () => useContext(context);

export const BuyingTeamDialogsProvider = ({ children }: ContextProps) => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  const settingsDialogState = useBoolean();
  const createDialogState = useBoolean();
  const confirmNewPersonaDialogState = useBoolean();
  const [name, setName] = useState<string>('');
  const [tabValue, setTabValue] = useState<string | undefined>(
    query.get('current_job_role_department') ?? JobFuntionsType.ALL_DEPARTMENTS
  );
  const [inputErrorMessage, setInputErrorMessage] = useState<string>();
  const editMode = useBoolean();
  const [selectedItem, setSelectedItem] = useState<ParsedPreset<DataConfig>>();

  return (
    <Provider
      value={{
        settingsDialogState,
        createDialogState,
        confirmNewPersonaDialogState,
        name,
        setName,
        tabValue,
        setTabValue,
        inputErrorMessage,
        setInputErrorMessage,
        editMode,
        selectedItem,
        setSelectedItem,
      }}
    >
      {children}
    </Provider>
  );
};
